import { render } from "./SidebarMain.vue?vue&type=template&id=7b9e2918&bindings={\"isMenuExpanded\":\"props\",\"ismobile\":\"props\",\"ismobileexpanded\":\"props\",\"showExtraMenu\":\"props\",\"isSidebarVisible\":\"options\",\"cssSideBarStyle\":\"options\",\"showSubmenu\":\"options\",\"focusSubmenu\":\"options\"}"
import script from "./SidebarMain.vue?vue&type=script&lang=js"
export * from "./SidebarMain.vue?vue&type=script&lang=js"

import "./SidebarMain.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script